function templateStringToLiteral(template: string, ...values: any[]): string {


  // if(!template && process.env.ENV !== "production") return "MISSING TEMPLATE STRING";
  if(!template && process.env.ENV !== "production") return "";
  
  if (!template) {
    console.warn("Template string is missing");
    return "";
  }

    // Regular expression to find placeholders
    const placeholderRegex = /\$\{(\w+)\}/g;
  
    // Extract variable names from the template string
    let match;
    const variableNames = [];
  
    while ((match = placeholderRegex.exec(template)) !== null) {
      variableNames.push(match[1]);
    }
  
    // Create a map of variable names to values
    const variablesMap = new Map();
    for (let i = 0; i < variableNames.length; i++) {
      variablesMap.set(variableNames[i], values[i]);
    }
  
    // Replace placeholders with corresponding values
    const result = template.replace(placeholderRegex, (_, variable) => {
      if (variablesMap.has(variable)) {
        return variablesMap.get(variable);
      } else {
        // If no corresponding value is found, keep the placeholder unchanged
        return `\${${variable}}`;
      }
    });
  
    return result;
  }


  const tstl = templateStringToLiteral
  export {tstl}